// Shared validation for shipping/customer detail forms across Checkout and Slab Order.

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
// Indian mobile: 10 digits starting 6-9. Allow optional +91 / 91 / 0 prefix and spaces/dashes.
const PHONE_STRIP_RE = /[\s\-()]/g;
const PIN_RE = /^\d{6}$/;

export function validateShippingForm(f = {}) {
  const errors = {};

  const name = String(f.full_name || "").trim();
  if (!name) errors.full_name = "Full name is required";
  else if (name.length < 3) errors.full_name = "Enter your full name (at least 3 characters)";
  else if (!/[a-zA-Z\u0900-\u097F]/.test(name)) errors.full_name = "Enter a valid name";

  const email = String(f.email || "").trim();
  if (!email) errors.email = "Email is required";
  else if (!EMAIL_RE.test(email)) errors.email = "Enter a valid email (e.g. you@example.com)";

  const phoneRaw = String(f.phone || "").replace(PHONE_STRIP_RE, "");
  // Accept optional +91/91/0 prefix, then 10 digits starting 6-9
  const phoneMatch = phoneRaw.match(/^(?:\+?91|0)?([6-9]\d{9})$/);
  if (!phoneRaw) errors.phone = "Phone number is required";
  else if (!phoneMatch) errors.phone = "Enter a valid 10-digit Indian mobile number";

  const address = String(f.address || "").trim();
  if (!address) errors.address = "Address is required";
  else if (address.length < 10) errors.address = "Enter your complete address (house/street/area)";

  const city = String(f.city || "").trim();
  if (!city) errors.city = "City is required";
  else if (city.length < 2) errors.city = "Enter a valid city name";
  else if (!/^[a-zA-Z\u0900-\u097F\s.'-]+$/.test(city)) errors.city = "City name looks invalid";

  const state = String(f.state || "").trim();
  if (!state) errors.state = "Select a state";

  const pin = String(f.postal_code || "").replace(/\D/g, "");
  if (!pin) errors.postal_code = "Postal code is required";
  else if (!PIN_RE.test(pin)) errors.postal_code = "PIN must be exactly 6 digits";

  return {
    errors,
    hasErrors: Object.keys(errors).length > 0,
  };
}

// Convenience: normalized values that can be sent to backend (trimmed, phone digits-only)
export function normalizeShippingForm(f = {}) {
  const phoneRaw = String(f.phone || "").replace(PHONE_STRIP_RE, "");
  const phoneMatch = phoneRaw.match(/^(?:\+?91|0)?([6-9]\d{9})$/);
  const phone = phoneMatch ? phoneMatch[1] : phoneRaw;
  return {
    ...f,
    full_name: String(f.full_name || "").trim(),
    email: String(f.email || "").trim(),
    phone,
    address: String(f.address || "").trim(),
    city: String(f.city || "").trim(),
    state: String(f.state || "").trim(),
    postal_code: String(f.postal_code || "").replace(/\D/g, ""),
    notes: String(f.notes || "").trim(),
  };
}
